// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"2b3eba29","229":"2a8a26e9","365":"6a7a2f88","453":"a5072149","859":"5faf4fc5","928":"b53c51b8"}[chunkId] + ".chunk.js";
};